import { create } from "zustand";

type TAssetsFilterStore = {
  filters: Record<string, string[]>;
  addFilter: (filterKey: string, value: string) => void;
  removeFilter: (filterKey: string, value: string) => void;
  resetFilters: (filterKey: string) => void;
  resetAllFilters: () => void;
  getValues: (filterKey: string) => string[];
};

export const useAssetsFilterBaseStore = create<TAssetsFilterStore>((set, get) => ({
  filters: {},
  addFilter: (filterKey, value) =>
    set((state) => {
      const existingFilters = state.filters[filterKey] || [];
      if (existingFilters.includes(value)) return state;

      return {
        filters: {
          ...state.filters,
          [filterKey]: [...existingFilters, value],
        },
      };
    }),
  removeFilter: (filterKey, value) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [filterKey]: (state.filters[filterKey] || []).filter((item) => item !== value),
      },
    })),
  resetFilters: (filterKey) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [filterKey]: [],
      },
    })),
  resetAllFilters: () => set({ filters: {} }),
  getValues: (filterKey) => get().filters[filterKey] || [],
}));

export const useAssetsFilterStore = (filterKey: string) => {
  const addFilter = useAssetsFilterBaseStore((state) => state.addFilter);
  const removeFilter = useAssetsFilterBaseStore((state) => state.removeFilter);
  const resetFilters = useAssetsFilterBaseStore((state) => state.resetFilters);
  const filters = useAssetsFilterBaseStore((state) => state.filters);

  const values = filterKey === "all" ? Object.values(filters).flat() : filters[filterKey] || [];

  return {
    values,
    filters,
    addFilter: (value: string) => addFilter(filterKey, value),
    removeFilter: (value: string) => removeFilter(filterKey, value),
    resetFilters: () => resetFilters(filterKey),
  };
};
